<div class="col-span-12 flex flex-col gap-(--spacing-layout-l)">
  <div class="flex justify-between items-center">
    <span class="text-heading-small text-primaryText">
      {{ 'RM.DASHBOARD.OPEN_ACTIONS.TITLE' | translate }}
    </span>
    <div class="flex items-center gap-3">
      @if (showViewAll()) {
        <app-button
          [label]="('RM.DASHBOARD.OPEN_ACTIONS.VIEW_ALL' | translate) + ' (' + totalCount() + ')'"
          variant="text"
          endIcon="/icons/arrow-right.svg"
          (onClick)="onViewAll()"
        />
      }
    </div>
  </div>
  <app-card variant="elevated" rootClass="h-full" bodyClass="h-full" contentClass="h-full">
    <div class="flex flex-col gap-4 p-5">
      <div class="grid grid-cols-12 gap-3 px-1 text-subheading-medium text-bodyText">
        <div class="col-span-12 md:col-span-6">{{ 'RM.DASHBOARD.OPEN_ACTIONS.COLUMNS.TASK' | translate }}</div>
        <div class="col-span-4 md:col-span-3">{{ 'RM.DASHBOARD.OPEN_ACTIONS.COLUMNS.PRIORITY' | translate }}</div>
        <div class="col-span-4 md:col-span-3">{{ 'RM.DASHBOARD.OPEN_ACTIONS.COLUMNS.STATUS' | translate }}</div>
      </div>

      @if (loading()) {
        @for (_ of [1, 2, 3, 4, 5]; track $index) {
          <div class="grid grid-cols-12 gap-3 items-center py-3 border-t border-primaryBorder">
            <div class="col-span-12 md:col-span-6 flex items-center gap-3">
              <p-skeleton shape="circle" size="2.5rem" />
              <div class="flex flex-col gap-2 flex-1">
                <p-skeleton height="1rem" width="60%" />
                <p-skeleton height="0.75rem" width="80%" />
              </div>
            </div>
            <div class="col-span-4 md:col-span-3"><p-skeleton height="1.5rem" width="4rem" borderRadius="12px" /></div>
            <div class="col-span-4 md:col-span-3"><p-skeleton height="1.5rem" width="5rem" borderRadius="12px" /></div>
          </div>
        }
      } @else if (!items().length) {
        <div class="flex items-center justify-center min-h-[120px] text-bodyText border-t border-primaryBorder">
          {{ 'RM.DASHBOARD.OPEN_ACTIONS.EMPTY' | translate }}
        </div>
      } @else {
        @for (item of items(); track item.id) {
          <div
            class="grid grid-cols-12 gap-3 items-center py-3 border-t border-primaryBorder"
            [class.cursor-pointer]="hasActionLink(item)"
            [attr.role]="hasActionLink(item) ? 'button' : null"
            [attr.tabindex]="hasActionLink(item) ? 0 : null"
            (click)="onActionClick(item)"
            (keydown.enter)="onActionClick(item)"
          >
            <div class="col-span-12 md:col-span-6 flex items-start gap-3 min-w-0">
              <div class="flex items-center justify-center w-10 h-10 rounded-full shrink-0 bg-surface-100">
                <svg-icon [src]="getTaskIconPath(item.priority)" svgClass="w-5 h-5 text-headingText"></svg-icon>
              </div>
              <div class="flex flex-col min-w-0 gap-0.5">
                <span class="text-subheading-medium text-headingText">{{ item.title }}</span>
                <span class="text-body-large text-bodyText">{{ item.description || '-' }}</span>
              </div>
            </div>
            <div class="col-span-4 md:col-span-3">
              <app-tag [value]="priorityLabel(item.priority)" [severity]="prioritySeverity(item.priority)" />
            </div>
            <div class="col-span-4 md:col-span-3">
              <app-tag [value]="statusLabel(item.status)" [severity]="statusSeverity(item.status)" />
            </div>
          </div>
        }
      }
    </div>
  </app-card>
</div>
